import { TableFilterType } from 'features/TableFilter';
import { getFilterServerFormatDate } from 'shared/utils/helpers/getDateFormat';

interface BoxesRevenueFilters {
  warehouseId?: string;
  isApplicable?: boolean;
  startDate?: string;
  endDate?: string;
  unitName?: string;
  squareFrom?: number;
  squareTo?: number;
}

export const transformBoxesRevenueFilters = ({
  selectedWarehouses,
  isApplicable,
  startDate,
  endDate,
  unitName,
  squareFrom,
  squareTo,
}: TableFilterType): BoxesRevenueFilters => {
  return {
    warehouseId: selectedWarehouses?.value || undefined,
    isApplicable: isApplicable?.value === undefined ? undefined : isApplicable?.value === 'applicable',
    startDate: getFilterServerFormatDate(startDate?.value),
    endDate: getFilterServerFormatDate(endDate?.value),
    unitName: unitName?.value || undefined,
    squareFrom: squareFrom?.value || undefined,
    squareTo: squareTo?.value || undefined,
  };
};
